
import { Introduccion } from "../../components/quienessomos/Introduccion";
import { Mapa } from "../../components/quienessomos/Mapa";
import { Administracion } from "../../components/quienessomos/Administracion";
export const QuienesSomos = () =>{
    return(
        <>
            <Introduccion/>
         
            <Administracion/>
        </>
    )
}